import { createSlice } from "@reduxjs/toolkit";

export const initialSignOffTaskLocalState = {
  crews: [
    {
      departed_time: null,
      returned_time: null,
      notes: null,
      is_crew_complaints: false,
      is_customer_complaints: false,
      assets: [
        {
          wage: null,
          overtime: null,
          review: null,
          review_score: null,
          driving_bonus: null,
          driving_speed: null,
          driving_style: null,
          notes: null,
        },
      ],
      tasks: [
        {
          notes: null,
        },
      ],
    },
  ],
};

export const signOffTaskSlice = createSlice({
  name: "signOffTask",
  initialState: {
    signOffTasks: [],
    isSignOffTaskResponse: false,
    isAddSignOffTaskSuccess: false,
    isSignOffTaskError: false,
    newSignOffTaskLocal: initialSignOffTaskLocalState,
  },

  reducers: {
    getAllSignOffTasks: (state, { payload }) => {},
    setAllSignOffTasks: (state, { payload }) => {
      state.signOffTasks = payload;
    },

    addSignOffTaskAction: (state, { payload }) => {},
    setAddSignOffTaskResponse: (state, { payload }) => {
      state.isAddSignOffTaskSuccess = payload;
    },
    updateSignOffTasksAction: (state, { payload }) => {
      console.log("updateSignOffTasks", payload);
    },

    updateSignOffTaskResponse: (state, { payload }) => {
      state.isSignOffTaskResponse = payload;
    },

    updateSingleSignOffTaskAction: (state, { payload }) => {},

    updateSignOffTaskError: (state, { payload }) => {
      state.isSignOffTaskError = payload;
    },

    getAllSignOffTasksById: (state, { payload }) => {},
    setNewSignOffTaskLocal: (state, action) => {
      state.newSignOffTaskLocal = {
        ...state.newSignOffTaskLocal,
        ...action.payload,
      };
    },

    resetNewSignOffTaskLocal: (state) => {
      state.newSignOffTaskLocal = initialSignOffTaskLocalState;
    },
  },
});

const {
  getAllSignOffTasks,
  setAllSignOffTasks,
  addSignOffTaskAction,
  setAddSignOffTaskResponse,
  updateSignOffTasksAction,
  updateSignOffTaskResponse,
  getAllSignOffTasksById,
  setNewSignOffTaskLocal,
  resetNewSignOffTaskLocal,
} = signOffTaskSlice.actions;

export {
  getAllSignOffTasks,
  setAllSignOffTasks,
  addSignOffTaskAction,
  setAddSignOffTaskResponse,
  updateSignOffTasksAction,
  updateSignOffTaskResponse,
  getAllSignOffTasksById,
  setNewSignOffTaskLocal,
  resetNewSignOffTaskLocal,
};

export default signOffTaskSlice.reducer;
